import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/patrimonio/manutencao/alerta' };
/////////////////////////////////////////////////////////////////////////////////

export function createPatrimonioAlertaManutencaoCadastro(payload) {
  return httpService.post(args, payload);
}

export function updatePatrimonioAlertaManutencaoCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listPatrimonioAlertaManutencaoCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findPatrimonioAlertaManutencaoCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllPatrimonioAlertaManutencaoCadastro() {
  return httpService.get({ ...args, path: '/patrimonio/manutencao/alerta/all' });
}

export function deletePatrimonioAlertaManutencaoCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

export function attachFiles(itemId, payload) {
  return httpService.putAttachFiles({ ...args, args: `/attachFiles/${itemId}` }, payload);
}

export function deleteAttachFiles(itemId, filesIdList) {
  return httpService.putDeleteFiles({ ...args, args: `/deleteFiles/${itemId}` }, filesIdList);
}

export function filterPatrimonioAlertaManutencao(datas, where) {
  return httpService.get({ ...args, args: `/filterAlertaManutencao?datas=${datas}${where}` });
}
